const SimulationEffectDateExtraInfoMessage = () => null;

export default SimulationEffectDateExtraInfoMessage;
